
<template>
  <div>
    <v-form ref="newExecution">
      <v-row>
        <v-col cols="12" lg="6" class="py-0">
          <v-text-field label="Nome da medição" v-model="name"></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="py-0">
          <new-execution-date></new-execution-date>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <select-job-interval></select-job-interval>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <new-execution-department></new-execution-department>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
            :items="model_options"
            item-text="name"
            item-value="value"
            v-model="model"
            label="Escolha o modelo para criação"
            :rules="required"
          ></v-select>
        </v-col>
      </v-row>
      <div v-if="model == 'model_1'">
        <model-one-new-execution></model-one-new-execution>
      </div>
      <div v-if="model == 'model_2'">
        <!-- <model-two-new-execution></model-two-new-execution> -->
      </div>
    </v-form>
    <div class="d-flex justify-center pt-3">
      <v-btn color="success" @click="newExecution()"><v-icon left>mdi-content-save</v-icon>Marcar Medição</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'CreateExecutionForm',
  components: {
    ModelOneNewExecution: () => import('./model_1/ModelOneNewExecution.vue'),
    ModelTwoNewwExecution: () => import('./model_2/ModelTwoNewExecution.vue'),
    NewExecutionDate: () => import('./shared/NewExecutionDate.vue'),
    NewExecutionDepartment: () => import('./shared/NewExecutionDepartment.vue'),
    SelectJobInterval: () => import('./shared/SelectJobInterval.vue')
  },
  mixins: [ validations ],
  data() {
    return {
      model: null,
      name: '',
      model_options: [
        { name: 'Modelo 1 - Por pessoa', value: 'model_1' },
        { name: 'Modelo 2 - Por categoria', value: 'model_2' }
      ]
    }
  },
  methods: {
    async newExecution() {
      let prep_exec = {
        name: this.name,
        kind: this.model
      }
      if (this.$refs.newExecution.validate() && this.department_id) {
        await this.createExecution({data: prep_exec});
        this.$router.push({name: 'ExecutionList'});
      }
    },
    ...mapActions({
      createExecution: 'Execution/create'
    })
  },
  computed: {
    ...mapState({
      department_id: state => state.Execution.department_id
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>